"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onKeyDown = void 0;
var React = require("react");
exports.onKeyDown = function (props) { return function (event) {
    if (event.key.toLowerCase() === 'enter') {
        event.preventDefault();
        return props.onKeywordEnter();
    }
    if (event.key.toLowerCase() === 'escape') {
        event.preventDefault();
        return props.onKeywordEscape();
    }
    if (event.key.toLowerCase() === 'arrowup') {
        event.preventDefault();
        return props.onKeywordPrevious();
    }
    if (event.key.toLowerCase() === 'arrowdown') {
        event.preventDefault();
        return props.onKeywordNext();
    }
}; };
var hfilterKeywordPanel = function (props) {
    var renderKeywordSuggestions = function (props) {
        if (props.keywordSuggestionsLoading) {
            return (React.createElement("div", { className: "c-hfilterpanel__body" },
                React.createElement("div", { className: "c-hfilterpanel__loading" },
                    React.createElement("span", { className: "fal fa-spin fa-undo" }))));
        }
        if (props.keywordSuggestionGroups.length) {
            return (React.createElement(React.Fragment, null,
                props.keywordSuggestionGroups.map(renderSuggestionGroup(props.keywordGroupIndex, props.keywordRowIndex)),
                React.createElement("div", { className: "c-hfilterpanel__foot c-hfilterpanel__foot--sm" })));
        }
        return (React.createElement("div", { className: "c-hfilterpanel__empty" },
            React.createElement("span", { className: "c-hfilterpanel__empty-text" }, props.t.keywordEmptyHint)));
    };
    var renderSuggestion = function (groupIndex, rowIndex, currentGroupIndex) { return function (suggestion, index) {
        var onMouseEnter = function () { return props.onSuggestionMouseEnter(currentGroupIndex, index); };
        var onClick = function () { return props.onSuggestionClick(currentGroupIndex, index); };
        var isCurrentGroup = groupIndex === currentGroupIndex;
        var isCurrentRow = rowIndex === index && isCurrentGroup;
        return (React.createElement("div", { onClick: onClick, onMouseEnter: onMouseEnter, key: index, className: "c-hfilterpanel__suggestion " + (isCurrentRow ? 'c-hfilterpanel__suggestion--active' : '') },
            React.createElement("div", { className: "c-hfilterpanel__suggestion-text" }, suggestion.name)));
    }; };
    var renderSuggestionGroup = function (groupIndex, rowIndex) { return function (suggestionGroup, i) {
        return (React.createElement("div", { key: i },
            React.createElement("div", { className: "c-hfilterpanel__head" },
                React.createElement("div", { className: "c-hfilterpanel__title" }, suggestionGroup.name)),
            React.createElement("div", { className: "c-hfilterpanel__body" },
                React.createElement("div", { className: "c-hfilterpanel__suggestions" }, suggestionGroup.suggestions.map(renderSuggestion(groupIndex, rowIndex, i))))));
    }; };
    if (props.keyword.trim()) {
        return renderKeywordSuggestions(props);
    }
    else {
        if (!props.keywordSuggestionGroups.length && (!props.keywordHistoryGroups.length || !props.keywordHistoryGroups[0].suggestions.length)) {
            return (React.createElement("div", { className: "c-hfilterpanel__empty" },
                React.createElement("span", { className: "c-hfilterpanel__empty-text" }, props.t.keywordEmptyHint)));
        }
        else {
            return (React.createElement(React.Fragment, null,
                props.keywordHistoryGroups.map(renderSuggestionGroup(props.keywordGroupIndex, props.keywordRowIndex)),
                React.createElement("div", { className: "c-hfilterpanel__foot c-hfilterpanel__foot--sm" })));
        }
    }
};
exports.default = hfilterKeywordPanel;
